<template>
  <div class="add-position-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/sys/position">岗位管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="系统" prop="companyId">
          <el-select v-model="ruleForm.companyId" placeholder="请选择系统" clearable style="width: 100%;">
            <el-option
              v-for="item in companyOptions"
              :key="item.companyId"
              :label="item.companyName"
              :value="item.companyId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上级岗位" prop="positionParentId" v-if="positionTree.length != 0">
            <el-input v-model="ruleForm.positionParentName" placeholder="请选择上级岗位" @focus="dialogVisible = true"></el-input>
        </el-form-item>
        <el-form-item label="岗位名称" prop="positionName">
            <el-input v-model="ruleForm.positionName" placeholder="请输入岗位名称"></el-input>
        </el-form-item>
        <el-form-item label="岗位编码" prop="positionCode">
            <el-input v-model="ruleForm.positionCode" placeholder="请输入岗位编码"></el-input>
        </el-form-item>
        <el-form-item label="显示顺序" prop="sortNo">
            <el-input v-model="ruleForm.sortNo" placeholder="请输入显示顺序"></el-input>
        </el-form-item>
        <el-form-item label="岗位状态">
          <el-radio-group v-model="ruleForm.positionStatus">
            <el-radio label="0">启用</el-radio>
            <el-radio label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="$router.back()">取 消</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="changePostData('ruleForm')">确 定</el-button>
      </div>
    </el-card>
    <el-dialog
      title="上级岗位"
      :visible.sync="dialogVisible"
      width="30%"
      top="5vh"
      append-to-body
      :before-close="handleClose"
    >
      <el-tree
        ref="tree"
        :data="positionTree"
        show-checkbox
        node-key="positionId"
        @check="checkPosition"
        :props="defaultProps"
      >
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSystemData } from '@/api/systemMange';
import { changePostData, addPostData, getPositionTree } from '@/api/postManage';
export default {
  data () {
    return {
      dialogVisible: false,
      title: "新增岗位",
      showParentPosition: false,
      companyOptions: [],
      positionTree: [], // 部门树结构
      // 新增/编辑岗位表单
      ruleForm: {
        companyId: '',
        positionName: '',
        positionCode: '',
        positionParentId: null, // 父级岗位Id
        positionParentName: '', // 父级岗位名称
        sortNo: '',
        positionStatus: '0',
        userCode: ''
      },
      rules: {
        companyId: [
            {required: true, message: '请选择系统', trigger: ['change', 'blur']}
        ],
        positionName: [
            {required: true, message: '请输入岗位名称', trigger: 'blur'}
        ],
        positionCode: [
            {required: true, message: '请输入岗位编码', trigger: 'blur'}
        ],
        sortNo: [
            {required: true, message: '请输入显示顺序', trigger: 'blur'}
        ],
        positionParentId: [
          { required: true, message: '请选择上级岗位', trigger: ['blur', 'change'] }
        ]
      },
      defaultProps: {
        children: 'children',
        label: 'positionName'
      }
    };
  },

  watch: {
    "ruleForm.companyId"(newVal, oldVal){
      if(newVal){
        this.searchPositionList(newVal)
      }
    }
  },

  created() {
    if('positionName' in JSON.parse(this.$route.query.item)){
      this.title = '岗位编辑'
      this.ruleForm = JSON.parse(this.$route.query.item)
    }else{
      this.title = '岗位新增'
    }
    this.getAllSystemInfo()
  },

  methods: {
    // 查询所有系统信息
    async getAllSystemInfo() {
      let searchSystemParams = {
        pageNo: 1,
        pageSize: 100,
        companyName: '',
        userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
      }
      const res = await getSystemData(searchSystemParams);
      if (res.code === '200') {
        this.companyOptions = res.data.list
      } else {
        this.$message.error(res.msg)
      }
    },
    // dialog确认事件
    changePostData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.title == '岗位新增' ? this.confirmAddPostData() : this.confirmEditPostData()
        } else {
          return false;
        }
      });
    },
    // 新增岗位
    async confirmAddPostData() {
      this.ruleForm.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
      const res = await addPostData(this.ruleForm);
      if (res.code === '200') {
        this.$message.success('新增成功')
        this.changeVisible = false
        this.$router.back()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 编辑岗位
    async confirmEditPostData() {
      this.ruleForm.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
      const res = await changePostData(this.ruleForm);
      if (res.code === '200') {
        this.$message.success('修改成功')
        this.changeVisible = false
        this.$router.back()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 查询岗位树结构
    async searchPositionList(val){
      let params = {
        companyId: val,
        userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
      }
      const res = await getPositionTree(params);
      if(res.code !== 'oxcrm3202125') {
        this.positionTree = res.data
      }else{
        this.positionTree = []
      }
    },
    checkPosition(data, checked, node){
      this.ruleForm.positionParentId = data.positionId
      this.ruleForm.positionParentName = data.positionName
      if(data){
        this.$refs.tree.setCheckedNodes([data])
      }
    },
    handleClose(){
      this.dialogVisible = false
    }
  }

}

</script>
<style scoped>
::v-deep .el-form{
  width: 50%;
  margin: 0 auto;
}
</style>
<style lang='scss' scoped>
.dialog-footer{
  text-align: center;
}
</style>